// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The application styles are scoped below the application root, so that they don't reach into
   the document, which may belong to a host application the viewer is embedded in. The scope is
   :where(), which contributes no specificity, so that the cascade is unaffected. */
:where(.qwc-root), :where(.qwc-root) *, :where(.qwc-root):after, :where(.qwc-root):before, :where(.qwc-root) *:after, :where(.qwc-root) *:before {
    box-sizing: border-box;
}

:where(.qwc-root), :where(.qwc-root) * {
    cursor: inherit;
}

:where(.qwc-root) {
    cursor: default;
    color: var(--text-color);
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
}

html:has(div.qwc-root-toplevel), html:has(div.qwc-root-toplevel) body {
    overflow: hidden;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

div.plugins-container.qwc-root-toplevel {
    position: fixed;
}

div.plugins-container.qwc-root-embedded {
    /* Keep the z-index stack of the viewer to itself, rather than competing with the host page */
    isolation: isolate;
}

:where(.qwc-root) a {
    cursor: pointer;
    color: var(--text-color-link);
    text-decoration: none;
}

:where(.qwc-root) a:hover {
    text-decoration: underline;
}

:where(.qwc-root) h1, :where(.qwc-root) h2, :where(.qwc-root) h3, :where(.qwc-root) h4 {
    font-weight: 500;
    margin: 0.5em 0;
}

:where(.qwc-root) h1 { font-size: 160%; }
:where(.qwc-root) h2 { font-size: 150%; }
:where(.qwc-root) h3 { font-size: 140%; }
:where(.qwc-root) h4 { font-size: 130%; }
:where(.qwc-root) h5 { font-size: 120%; }
:where(.qwc-root) h6 { font-size: 110%; }

:where(.qwc-root) table {
    border-collapse: collapse;
    font-size: 14px;
}

:where(.qwc-root) ul {
    margin: 0;
}

:where(.qwc-root) input, :where(.qwc-root) select, :where(.qwc-root) button, :where(.qwc-root) textarea {
    border-radius: 0;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
}

:where(.qwc-root) input:focus, :where(.qwc-root) select:focus, :where(.qwc-root) button:focus, :where(.qwc-root) textarea:focus {
    outline: var(--focus-outline);
}

:where(.qwc-root) textarea, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]), :where(.qwc-root) select {
    padding: 0.25em;
    border: 1px solid var(--border-color);
    background-color: var(--input-bg-color);
    color: var(--text-color);
}

:where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]), :where(.qwc-root) select {
    height: 2em;
    border-radius: var(--border-radius);
}

:where(.qwc-root) textarea, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]) {
    cursor: text;
}

:where(.qwc-root) input:read-only, :where(.qwc-root) textarea:read-only, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]):read-only {
    color: var(--text-color-disabled);
}

:where(.qwc-root) input:disabled, :where(.qwc-root) select:disabled, :where(.qwc-root) textarea:disabled {
    background-color: var(--input-bg-color-disabled);
    color: var(--text-color-disabled);
}

:where(.qwc-root) input:invalid, :where(.qwc-root) select:invalid, :where(.qwc-root) textarea:invalid, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]):invalid {
    background-color: #FFAAAA;
}

/** Button **/
:where(.qwc-root) button.button {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border: 1px solid var(--border-color);
    display: inline-flex;
    padding: 0.5em;
    align-items: center;
    justify-content: center;
    height: 2em;
    overflow: hidden;
    cursor: pointer;
    outline: none;
}

:where(.qwc-root) button.button:focus {
    outline: var(--focus-outline);
}

:where(.qwc-root) button.button:disabled {
    background-color: var(--button-bg-color-disabled);
    color: var(--button-text-color-disabled);
    cursor: default;
}

:where(.qwc-root) button.button:not(:disabled):hover {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

:where(.qwc-root) button.button.pressed:not(:disabled):hover {
    background-color: var(--button-bg-color-active-hover);
    color: var(--button-text-color-active-hover);
}

:where(.qwc-root) button.button.pressed:not(:disabled) {
    background-color: var(--button-bg-color-active);
    color: var(--button-text-color-active);
}

:where(.qwc-root) button.button-accept {
    background-color: rgb(127,255,127);
}

:where(.qwc-root) button.button-warning {
    background-color: #ffd979;
}

:where(.qwc-root) button.button-reject {
    background-color: rgb(255,127,127);
}

:where(.qwc-root) button.button-warning:not(:disabled):hover {
    background-color: #f5ce74;
}

:where(.qwc-root) button.button-accept:not(:disabled):hover {
    background-color: rgb(127,225,127);
}

:where(.qwc-root) button.button-reject:not(:disabled):hover {
    background-color: rgb(225,127,127);
}

:where(.qwc-root) button.button > * {
    flex: 0 0 auto;
}

:where(.qwc-root) button.button:not(:disabled):active > * {
    transform: translateX(1px) translateY(1px);
}

:where(.qwc-root) button.button > span:not(.icon) {
    margin: 0 0.25em;
}

:where(.qwc-root) button.button > div.spinner {
    width: 1.5em;
    height: 1.5em;
}

:where(.qwc-root) button.selected {
    position: relative;
}
:where(.qwc-root) button.selected:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background-color: var(--color-active);
    border-top: 1px solid var(--border-color);
    content: "";
}

:where(.qwc-root) div.controlgroup {
    display: flex;
    align-items: center;
}

:where(.qwc-root) div.controlgroup > .controlgroup-fillitem {
    flex: 1 1 auto;
    width: 0;
}

:where(.qwc-root) div.controlgroup > .controlgroup-expanditem {
    flex: 1 0 auto;
}

:where(.qwc-root) div.controlgroup > *:not(:last-child):not(span) {
    margin-right: -1px;
}

/** Range slider **/
:where(.qwc-root) input[type=range] {
    -webkit-appearance: none;
    appearance: none;
    background-color: transparent;
    height: 2em;
}

:where(.qwc-root) input[type=range]::-moz-range-track {
    background: #ddd;
    height: 4px;
}

:where(.qwc-root) input[type=range]::-webkit-slider-runnable-track {
    background: #ddd;
    height: 4px;
}

:where(.qwc-root) input[type=range]::-moz-range-thumb {
    appearance: none;
    -webkit-appearance: none;
    border: 1px solid var(--border-color);
    border-radius: 50%;
    height: 12px;
    width: 12px;
    box-sizing: border-box;
    background: var(--input-bg-color);
    margin-top: -3.5px;
}

:where(.qwc-root) input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid var(--border-color);
    border-radius: 50%;
    height: 12px;
    width: 12px;
    box-sizing: border-box;
    background: var(--input-bg-color);
    margin-top: -3.5px;
}

:where(.qwc-root) div.__event_shield {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999999999999;
}`, "",{"version":3,"sources":["webpack://./components/style/App.css"],"names":[],"mappings":"AAAA;;mFAEmF;AACnF;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,wDAAwD;IACxD,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6FAA6F;IAC7F,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;;AAExC;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gDAAgD;IAChD,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,qCAAqC;IACrC,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,qDAAqD;IACrD,4CAA4C;AAChD;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,qCAAqC;IACrC,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;IACxB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,qBAAqB;AACzB","sourcesContent":["/* The application styles are scoped below the application root, so that they don't reach into\n   the document, which may belong to a host application the viewer is embedded in. The scope is\n   :where(), which contributes no specificity, so that the cascade is unaffected. */\n:where(.qwc-root), :where(.qwc-root) *, :where(.qwc-root):after, :where(.qwc-root):before, :where(.qwc-root) *:after, :where(.qwc-root) *:before {\n    box-sizing: border-box;\n}\n\n:where(.qwc-root), :where(.qwc-root) * {\n    cursor: inherit;\n}\n\n:where(.qwc-root) {\n    cursor: default;\n    color: var(--text-color);\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 14px;\n}\n\nhtml:has(div.qwc-root-toplevel), html:has(div.qwc-root-toplevel) body {\n    overflow: hidden;\n    margin: 0;\n    padding: 0;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\ndiv.plugins-container.qwc-root-toplevel {\n    position: fixed;\n}\n\ndiv.plugins-container.qwc-root-embedded {\n    /* Keep the z-index stack of the viewer to itself, rather than competing with the host page */\n    isolation: isolate;\n}\n\n:where(.qwc-root) a {\n    cursor: pointer;\n    color: var(--text-color-link);\n    text-decoration: none;\n}\n\n:where(.qwc-root) a:hover {\n    text-decoration: underline;\n}\n\n:where(.qwc-root) h1, :where(.qwc-root) h2, :where(.qwc-root) h3, :where(.qwc-root) h4 {\n    font-weight: 500;\n    margin: 0.5em 0;\n}\n\n:where(.qwc-root) h1 { font-size: 160%; }\n:where(.qwc-root) h2 { font-size: 150%; }\n:where(.qwc-root) h3 { font-size: 140%; }\n:where(.qwc-root) h4 { font-size: 130%; }\n:where(.qwc-root) h5 { font-size: 120%; }\n:where(.qwc-root) h6 { font-size: 110%; }\n\n:where(.qwc-root) table {\n    border-collapse: collapse;\n    font-size: 14px;\n}\n\n:where(.qwc-root) ul {\n    margin: 0;\n}\n\n:where(.qwc-root) input, :where(.qwc-root) select, :where(.qwc-root) button, :where(.qwc-root) textarea {\n    border-radius: 0;\n    color: inherit;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n}\n\n:where(.qwc-root) input:focus, :where(.qwc-root) select:focus, :where(.qwc-root) button:focus, :where(.qwc-root) textarea:focus {\n    outline: var(--focus-outline);\n}\n\n:where(.qwc-root) textarea, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]), :where(.qwc-root) select {\n    padding: 0.25em;\n    border: 1px solid var(--border-color);\n    background-color: var(--input-bg-color);\n    color: var(--text-color);\n}\n\n:where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]), :where(.qwc-root) select {\n    height: 2em;\n    border-radius: var(--border-radius);\n}\n\n:where(.qwc-root) textarea, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]) {\n    cursor: text;\n}\n\n:where(.qwc-root) input:read-only, :where(.qwc-root) textarea:read-only, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]):read-only {\n    color: var(--text-color-disabled);\n}\n\n:where(.qwc-root) input:disabled, :where(.qwc-root) select:disabled, :where(.qwc-root) textarea:disabled {\n    background-color: var(--input-bg-color-disabled);\n    color: var(--text-color-disabled);\n}\n\n:where(.qwc-root) input:invalid, :where(.qwc-root) select:invalid, :where(.qwc-root) textarea:invalid, :where(.qwc-root) input:not([type=checkbox]):not([type=radio]):not([type=range]):invalid {\n    background-color: #FFAAAA;\n}\n\n/** Button **/\n:where(.qwc-root) button.button {\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border: 1px solid var(--border-color);\n    display: inline-flex;\n    padding: 0.5em;\n    align-items: center;\n    justify-content: center;\n    height: 2em;\n    overflow: hidden;\n    cursor: pointer;\n    outline: none;\n}\n\n:where(.qwc-root) button.button:focus {\n    outline: var(--focus-outline);\n}\n\n:where(.qwc-root) button.button:disabled {\n    background-color: var(--button-bg-color-disabled);\n    color: var(--button-text-color-disabled);\n    cursor: default;\n}\n\n:where(.qwc-root) button.button:not(:disabled):hover {\n    background-color: var(--button-bg-color-hover);\n    color: var(--button-text-color-hover);\n}\n\n:where(.qwc-root) button.button.pressed:not(:disabled):hover {\n    background-color: var(--button-bg-color-active-hover);\n    color: var(--button-text-color-active-hover);\n}\n\n:where(.qwc-root) button.button.pressed:not(:disabled) {\n    background-color: var(--button-bg-color-active);\n    color: var(--button-text-color-active);\n}\n\n:where(.qwc-root) button.button-accept {\n    background-color: rgb(127,255,127);\n}\n\n:where(.qwc-root) button.button-warning {\n    background-color: #ffd979;\n}\n\n:where(.qwc-root) button.button-reject {\n    background-color: rgb(255,127,127);\n}\n\n:where(.qwc-root) button.button-warning:not(:disabled):hover {\n    background-color: #f5ce74;\n}\n\n:where(.qwc-root) button.button-accept:not(:disabled):hover {\n    background-color: rgb(127,225,127);\n}\n\n:where(.qwc-root) button.button-reject:not(:disabled):hover {\n    background-color: rgb(225,127,127);\n}\n\n:where(.qwc-root) button.button > * {\n    flex: 0 0 auto;\n}\n\n:where(.qwc-root) button.button:not(:disabled):active > * {\n    transform: translateX(1px) translateY(1px);\n}\n\n:where(.qwc-root) button.button > span:not(.icon) {\n    margin: 0 0.25em;\n}\n\n:where(.qwc-root) button.button > div.spinner {\n    width: 1.5em;\n    height: 1.5em;\n}\n\n:where(.qwc-root) button.selected {\n    position: relative;\n}\n:where(.qwc-root) button.selected:after {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 3px;\n    background-color: var(--color-active);\n    border-top: 1px solid var(--border-color);\n    content: \"\";\n}\n\n:where(.qwc-root) div.controlgroup {\n    display: flex;\n    align-items: center;\n}\n\n:where(.qwc-root) div.controlgroup > .controlgroup-fillitem {\n    flex: 1 1 auto;\n    width: 0;\n}\n\n:where(.qwc-root) div.controlgroup > .controlgroup-expanditem {\n    flex: 1 0 auto;\n}\n\n:where(.qwc-root) div.controlgroup > *:not(:last-child):not(span) {\n    margin-right: -1px;\n}\n\n/** Range slider **/\n:where(.qwc-root) input[type=range] {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: transparent;\n    height: 2em;\n}\n\n:where(.qwc-root) input[type=range]::-moz-range-track {\n    background: #ddd;\n    height: 4px;\n}\n\n:where(.qwc-root) input[type=range]::-webkit-slider-runnable-track {\n    background: #ddd;\n    height: 4px;\n}\n\n:where(.qwc-root) input[type=range]::-moz-range-thumb {\n    appearance: none;\n    -webkit-appearance: none;\n    border: 1px solid var(--border-color);\n    border-radius: 50%;\n    height: 12px;\n    width: 12px;\n    box-sizing: border-box;\n    background: var(--input-bg-color);\n    margin-top: -3.5px;\n}\n\n:where(.qwc-root) input[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    border: 1px solid var(--border-color);\n    border-radius: 50%;\n    height: 12px;\n    width: 12px;\n    box-sizing: border-box;\n    background: var(--input-bg-color);\n    margin-top: -3.5px;\n}\n\n:where(.qwc-root) div.__event_shield {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 999999999999;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
